import React from 'react';
import { motion } from 'framer-motion';

import banner2 from '../assets/banner2.png';

const Disclaimer = () => {

  return (
    <div className="bg-white min-h-screen">
      {/* ================= HERO SECTION (Standard Theme) ================= */}
      <section
        className="relative py-16 md:py-24 text-center overflow-hidden"
        style={{
          backgroundImage: `url(${banner2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <h3 className="relative z-10 font-syne text-[28px] md:text-[40px] text-slate-900 tracking-tight font-medium">
         Disclaimer
        </h3>

        <div
          className="pointer-events-none absolute bottom-0 left-0 w-full h-[120px]"
          style={{
            background:
              "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.35) 40%, rgba(255,255,255,0.7) 70%, rgba(255,255,255,1) 100%)",
          }}
        />
      </section>

      {/* ================= CONNECT DETAILS SECTION ================= */}
   
<section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-2 lg:px-4">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="space-y-6 text-slate-700 leading-relaxed text-base md:text-lg"
          >
            <p>
             These are our terms and conditions for usage of the website and the related services offered by DreamLadder Capital. (‘Related Services’ hereafter means Stock Market Trading / Mutual Funds / ULIPs / Investment Analysis given through E-Mail, Messenger, Mobile Phone, Mobile SMS, Telephone or in any other form, manner or media).
            </p>

            <p>
            DreamLadder Capital all its contents & related services. You agree and understand that the information and material contained in this website and the related services offered by DreamLadder Capital.
            </p>

            <p>
              Research’ implies and constitutes your consent to the terms and conditions mentioned below. You also agree that DreamLadder Capital can modify or alter the terms and conditions of the use of this service without any liability.
            </p>

            <p>
            The contents of this site & related services offered by DreamLadder Capital are solely the personal views of the contributors. DreamLadder Capital reserve the right to make modifications and alterations to the contents of this website. Users are advised to use the data for the purpose of information only and rely on their own judgment while making investment or trading decisions. The investments or trades discussed or recommended in this website & related services offered by DreamLadder Capital may not be suitable for all investors.
            </p>

            <p>
          DreamLadder Capital do not warranty the timeliness, accuracy or quality of the electronic content and take no responsibility for any loss or profit arising out of decisions being made by anyone acting on the analysis published in this website.
            </p>

            <p>
              The contents of this website & the related services offered by DreamLadder Capital cannot be copied, reproduced, republished, uploaded, posted, transmitted or distributed for any non-personal use without obtaining prior permission from DreamLadder Capital. Any person who intend to use the services rendered by DreamLadder Capital should do so only after due consideration of the above as well as all other factors.
            </p>

            <p>
             <strong>DreamLadder Capital is not responsible for the contents of any of the linked sites.</strong> By providing access to other website nor recommending nor endorsing the content available in the linked websites. If you do not agree to any of the terms mentioned in this agreement, you should kindly exit the site.
            </p>

          </motion.div>
        </div>
      </section>

    </div>
  );
};

export default Disclaimer;